export default angular
    .module('app.redevServices', [])
    // .service('httpRequest',[function httpRequest() {
    //     return 123
    // }])
    .name


//////////////////
// WEBPACK FOOTER
// ./redevelopment/common/services/index.js
// module id = 2XfA
// module chunks = 0